export default "__VITE_ASSET__DYXkf_ax__";